export const PAGE_CONFIG = {
  title: '异动日报',
  titleCN: '异动日报',
  subTitle: '',
  subTitleCN: '',
  path: '/report/abnormalReport',
  defaultTab: 'all',
  showHeader: false,
  showTimeZone: true,
  className: 'dbd-abnormal-report-page',
  tabList: [
    {
      id: 'all',
      tabName: 'All',
      tabNameCN: '所有',
      isHaveNotification: false,
      path: '/report/abnormalReport',
      logConfig: {
        pageId: '210101',
        pageName: 'AI Daily Report',
        extInfo: 'AIDailyReport',
        pagePath: '/report/abnormalReport',
      },
      filters: [
        {
          name: 'AbnormalReportAllFilter',
          isOpenSticky: true,
          isHaveFilterSave: false,
          filterPath: '/report/abnormalReport',
          enableDownload: true,
          downloadFileNameEn: 'AI Daily Report',
          downloadFileNameCn: 'AI 异动日报',
          downloadFormats: [
            { format: 'html' },
            { format: 'pdf' },
          ],
          componentList: [
            {
              name: 'AbnormalReportIframeCo',
              type: 'view',
            },
          ],
        },
      ],
    },
  ],
};
